import type { PropsWithChildren } from "react";

export function AppProviders({ children }: PropsWithChildren) {
  return children;
}
